<template>
  <div>
    <Tooltip v-if="adaptive" content="适应窗口" placement="top">
      <div class="pointer cell">
        <i
          class="ivu-icon-icon-pg-self-adaptive"
          size="23"
          @click="eventHandler('zoom-adaptived')"
        ></i>
      </div>
    </Tooltip>

    <Tooltip content="拖拽[长按空格键]" placement="top" v-if="showDrag">
      <div class="pointer cell" :class="{ down: isSpace }">
        <i
          class="ivu-icon-icon-pg-drag"
          size="23"
          @click="eventHandler('update:isSpace', !isSpace)"
        ></i>
      </div>
    </Tooltip>

    <Tooltip v-if="zoom" content="放大[ctrl+滚轮]" placement="top">
      <div class="pointer cell">
        <i class="ivu-icon-icon-pg-fangda" size="23" @click="eventHandler('zoomF', -1)"></i>
      </div>
    </Tooltip>

    <Tooltip v-if="zoom" content="缩小[ctrl+滚轮]" placement="top">
      <div class="pointer cell">
        <i class="ivu-icon-icon-pg-suoxiao" size="23" @click="eventHandler('zoomF', 1)"></i>
      </div>
    </Tooltip>

    <Tooltip v-if="zoom" content="实际大小" placement="top">
      <div class="proportion pointer cell" @click="eventHandler('zoom-origin')">
        {{ parseInt(zoomNum * 100) }}%
      </div>
    </Tooltip>

    <div v-if="onlyDownload" class="divider">|</div>

    <Tooltip content="下载" placement="top" v-if="download">
      <div class="pointer cell">
        <i class="ivu-icon-icon-pg-xiazai" size="23" @click="eventHandler('on-download')"></i>
      </div>
    </Tooltip>
    <Tooltip content="删除" placement="top" v-if="remove">
      <div class="pointer cell">
        <i class="ivu-icon-icon-pg-delete" size="23" @click="eventHandler('on-remove')"></i>
      </div>
    </Tooltip>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'
import { Tooltip } from 'element-ui'

const props = defineProps({
  zoomNum: { type: Number, default: 1 },
  onlyDownload: { type: Boolean, default: true },
  download: { type: Boolean, default: true },
  remove: { type: Boolean, default: false },
  adaptive: { type: Boolean, default: true },
  showDrag: { type: Boolean, default: true },
  zoom: { type: Boolean, default: true },
  isSpace: { type: Boolean, default: false },
})

const emit = defineEmits([
  'zoom',
  'on-download',
  'on-remove',
  'zoom-origin',
  'zoom-adaptived',
  'update:isSpace',
])

const { zoomNum, onlyDownload, download, adaptive } = toRefs(props)

const eventHandler = (eventName, value) => {
  emit(eventName, value)
}
</script>
